import { Skeleton } from "@/shared/ui/skeleton";

const FLOW_CARD_SKELETONS = [
  { id: "flow-1", titleWidth: "w-36", descriptionWidth: "w-72" },
  { id: "flow-2", titleWidth: "w-28", descriptionWidth: "w-60" },
  { id: "flow-3", titleWidth: "w-44", descriptionWidth: "w-80" },
];

export function FlowPageLoading() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="min-h-full py-6">
        <div className="mb-5">
          <h1 className="text-xl font-semibold tracking-tight">流程</h1>
          <p className="mt-0.5 text-sm text-muted-foreground">自动整理新收藏</p>
        </div>

        <div aria-label="正在加载流程" className="space-y-2" role="status">
          {FLOW_CARD_SKELETONS.map((item) => (
            <div
              className="flex min-h-20 items-center gap-3 rounded-lg bg-background px-3 py-3"
              key={item.id}
            >
              <Skeleton className="size-4 shrink-0" />
              <div className="min-w-0 flex-1">
                <Skeleton className={`h-4 ${item.titleWidth}`} />
                <Skeleton className={`mt-2 h-3 max-w-full ${item.descriptionWidth}`} />
                <div className="mt-2 flex items-center gap-2">
                  <Skeleton className="size-4 rounded-full" />
                  <Skeleton className="h-3 w-24" />
                </div>
              </div>
              <Skeleton className="h-5 w-9 rounded-full" />
              <Skeleton className="size-8" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
